module.exports = __webpack_public_path__ + "static/the-origins-of-political-order-c56774882da52624638c424ef5a42d5f.jpg";